module.exports = __webpack_public_path__ + "static/ARB_Logo-usage_correct3-c641cf417708364882a2cdc669ebf82a.jpg";